export const API_BASE = import.meta.env.VITE_API_BASE_URL || "https://pliego-api.mydash.workers.dev";

export async function api(path, options = {}) {
  const headers = new Headers(options.headers || {});
  headers.set("Accept", "application/json");
  const init = { ...options, headers };
  if (options.body && !(options.body instanceof FormData) && !(options.body instanceof Blob)) {
    headers.set("Content-Type", "application/json");
    init.body = JSON.stringify(options.body);
  }
  const response = await fetch(`${API_BASE}${path}`, init);
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    const error = new Error(payload.error || "No se ha podido completar la acción.");
    error.status = response.status;
    error.details = payload.details;
    throw error;
  }
  if (response.status === 204) return {};
  return response.json();
}

export function query(path, values = {}) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(values)) {
    if (value !== undefined && value !== null && value !== "") params.set(key, value);
  }
  const suffix = params.size ? `?${params}` : "";
  return api(`${path}${suffix}`);
}
